import { useContext } from 'react';
import { ServicingTransfersStore } from '../stores/servicingTransfersStore';
import { StoreContext } from '@roc/feature-app-core';

export const useServicingTransfersStore = () =>
  useContext<{
    servicingTransfersStore: ServicingTransfersStore;
  }>(StoreContext);
